import { takeEvery, put } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  createTransaction,
  deleteTrxnAttachment,
  downloadTrxnAttachment,
  getCashManagementList,
  getCashManagementSummary,
  getCurrentTransactionList,
  getOrderwisePayoutData,
  getReconAggregationData,
  getUploadedReportsMetaData,
  getAccountingSummary,
  getPaymentSummary,
  getCreditSummary,
  getUserCreditDetails,
  saveUserCreditDetails,
  getPaymentUserSummary,
  getPaymentUserSummaryDetails,
  getInvoiceDetails,
  getBillsDetails,
  getAuditLogDetails,
  getSubFilterDetails,
  saveCreditSummary,
  sendDigitalBillViaSMS,
  sendDigitalBillViaSMSSuccess,
  savePaymentUserSummaryDetails,
  saveAuditLogDetails,
  saveBillsDetails,
  saveInvoiceDetails,
  saveSubFilterDetails,
  sendDigiatlBillViaWA,
  sendDigitalBillViaWASuccess,
  sendDigiatlBillViaEmail,
  sendDigitalBillViaEmailSuccess,
  savePaymentSummary,
  savePaymentUserSummary,
  saveSaleGroupByBrand,
  saveAccountingSummary,
  saveCashManagementList,
  saveCashManagementSummary,
  saveOrderwisePayoutData,
  saveReconAggregationData,
  saveUploadedReportsMetaData,
  updateTransaction,
  uploadReconFile,
  uploadTrxnAttachment,
  getSaleGroupByBrand,
  getFranciseReport,
} from "../slices";
import { take } from "lodash";
import store from "../store";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  success?: boolean;
  code?: any;
  results?: any;
}

function* fetchReconAggregationData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getReconAggregationResults,
      data: actions.payload.dataToPost,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      yield put(saveReconAggregationData(response));
      actions?.payload?.callback && actions.payload.callback(true);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchUploadedReportsMetaData() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ACCOUNTING.getUploadedReportsMetaData,
    });
    if (response?.code) {
    } else {
      yield put(saveUploadedReportsMetaData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* uploadReconFileData(actions?: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.uploadReconFile,
      data: actions.payload.dataToPost,
    });
    actions?.payload?.callback && actions.payload.callback(response);
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchOrderwisePayoutData(actions?: any) {
  const orderType = actions.payload?.dataToPost?.orderType;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getOrderwisePayout,
      data: actions.payload.dataToPost,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      yield put(
        saveOrderwisePayoutData({
          response,
          orderType,
        })
      );
      actions?.payload?.callback && actions.payload.callback(true);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchCashManagementSummary(actions?: any) {
  const branchId = actions.payload?.dataToPost?.branchId;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ACCOUNTING.getCashManagementSummary(branchId),
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      yield put(saveCashManagementSummary(response));
      actions?.payload?.callback && actions.payload.callback(true);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchCashManagementList(actions?: any) {
  const dataToSend = actions.payload?.dataToPost;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getCashManagementList,
      data: dataToSend,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      yield put(saveCashManagementList(response));
      actions?.payload?.callback && actions.payload.callback(true, response);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* createTransactionData(actions?: any) {
  const dataToSend = actions.payload?.dataToPost;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.createTransaction,
      data: dataToSend,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      actions?.payload?.callback && actions.payload.callback(true, response);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* downloadTrxnAttachmentFile(actions?: any) {
  const { id, attachmentId, fileName } = actions.payload?.dataToPost;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ACCOUNTING.downloadTransactionAttachment(
        id,
        attachmentId,
        fileName
      ),
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      actions?.payload?.callback && actions.payload.callback(true, response);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* deleteTrxnAttachmentFile(actions?: any) {
  const { id, attachmentId, fileName } = actions.payload?.dataToPost;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.ACCOUNTING.deleteTransactionAttachment(
        id,
        attachmentId,
        fileName
      ),
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      actions?.payload?.callback && actions.payload.callback(true);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* updateTransactionData(actions?: any) {
  const { dataToPost, trxnId } = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.updateTransaction(trxnId),
      data: dataToPost,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      actions?.payload?.callback && actions.payload.callback(true, response);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* uploadTrxnAttachmentFile(actions?: any) {
  const { dataToPost, trxnId } = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.uploadTransactionAttachment(trxnId),
      data: dataToPost,
    });
    if (response?.code) {
      actions?.payload?.callback && actions.payload.callback(false);
    } else {
      actions?.payload?.callback && actions.payload.callback(true);
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchCurrentTransaction(actions: any) {
   try {
     const response: ResponseGenerator = yield api.request({
      method: 'GET',
      url: ENDPOINT.ACCOUNTING.currentTransaction
     })
      actions?.payload?.callback && actions.payload.callback(true, response);
   } catch(error) {
    actions?.payload?.callback && actions.payload.callback(false);
   }
}

function* fetchAccountingSummary(actions?: any) {
  const dataToPost = actions.payload;
  const isGroupByBrand = actions.payload.groupByBrand;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getAccountingSalesSummary,
      data: dataToPost,
    });
    if (!response?.code) {
      if(isGroupByBrand){
        yield put(saveSaleGroupByBrand(response));
      }
      else{
      yield put(saveAccountingSummary(response));}
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchPaymentSummary(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getAccountingPaymentSummary,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put(savePaymentSummary(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchCreditSummary(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getAccountingCreditSummary,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put(saveCreditSummary(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchPaymentUserSummary(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getPaymentSummaryUser,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put( savePaymentUserSummary(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchPaymentUserSummaryDetails(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getAccountingPaymentSummary,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put(savePaymentUserSummaryDetails(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchAuditLogDetails(actions?: any) {
  const dataToPost = actions.payload.dataToPost;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getSalesAuditLog,
      data: dataToPost,
    });
    if (response) {
      actions.payload.callback && actions.payload.callback(response);
    }
     yield put(saveAuditLogDetails(response));
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchUserCreditDetails(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getUserCreditDetails,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put(saveUserCreditDetails(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchBillsDetails(actions?: any) {
  const dataToPost = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.billsDetails,
      data: dataToPost,
    });
    if (!response?.code) {
      yield put(saveBillsDetails(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchInvoiceDetails(actions?: any) {
  const {saleId} = actions.payload;
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.ACCOUNTING.getInvoiceDetails(saleId),
    });
    if (!response?.code) {
      yield put(saveInvoiceDetails(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchFilterSummaryDetails(actions?: any) {
  const dataToPost = actions.payload.dataToPost;
  const isSubType = actions.payload.isSubType
  const currentData = store.getState()?.accountingReducer?.auditFilterDetails;
  try {
    const response: Record<string,any> = yield api.request({
      method: `POST`,
      url: ENDPOINT.ACCOUNTING.getSaleSubFilter,
      data: dataToPost
    });
    if (!response?.code) {
      if(isSubType && currentData?.auditSubTypes?.length)
      {
      response.auditSubTypes = [...currentData?.auditSubTypes]
      }
      yield put(saveSubFilterDetails(response));
    }
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* sendDigitalBillViaSMSFunc(actions?: any) {
  let payload = actions.payload?.payload;
  let mid = actions.payload?.mid
  try {
    const response: ResponseGenerator = yield api.request({
      method: "POST",
      url: ENDPOINT.ACCOUNTING.sendBillOnSMS(mid),
      data: payload,
    });
    actions.payload?.callback(response)
    yield put(sendDigitalBillViaSMSSuccess(response));
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* sendDigiatlBillViaEmailFunc(actions: any) {
  let mid = actions.payload.mid;
  let email = actions.payload.selectedContactNumber
  try {
    let response: Boolean = yield api.request({
      method: "POST",
      url: ENDPOINT.ACCOUNTING.sendBillOnEmail(mid, email),
    });
    if (Object.keys(response).length == 0) {
      response = true 
    }
    actions.payload?.callback(response)
    yield put(sendDigitalBillViaEmailSuccess(response));
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* sendDigiatlBillViaWAFunc(actions: any) {
  let payload = actions.payload?.payload;
  let mid = actions.payload?.mid
  try {
    const response: ResponseGenerator= yield api.request({
      method: "POST",
      url: ENDPOINT.ACCOUNTING.sendBillOnWhatsapp(mid),
      data: payload,
    });
    actions.payload?.callback(response)
    yield put(sendDigitalBillViaWASuccess(response));
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}

function* fetchFranchiseData(actions: any) {
  let payload = actions.payload?.dataToSend;
  let callback = actions.payload?.callback
  try {
    const response: ResponseGenerator= yield api.request({
      method: "POST",
      url: ENDPOINT.ACCOUNTING.getFranchiseReport,
      data: payload,
    });
    if(!response?.code)
    callback && callback(response)
  } catch (error) {
    console.log(error);
    actions?.payload?.callback && actions.payload.callback(false);
  }
}


export default function* root() {
  yield takeEvery(getReconAggregationData.type, fetchReconAggregationData);
  yield takeEvery(
    getUploadedReportsMetaData.type,
    fetchUploadedReportsMetaData
  );
  yield takeEvery(uploadReconFile.type, uploadReconFileData);
  yield takeEvery(getOrderwisePayoutData.type, fetchOrderwisePayoutData);
  yield takeEvery(getCashManagementSummary.type, fetchCashManagementSummary);
  yield takeEvery(getCashManagementList.type, fetchCashManagementList);
  yield takeEvery(getCurrentTransactionList.type, fetchCurrentTransaction)
  yield takeEvery(createTransaction.type, createTransactionData);
  yield takeEvery(downloadTrxnAttachment.type, downloadTrxnAttachmentFile);
  yield takeEvery(deleteTrxnAttachment.type, deleteTrxnAttachmentFile);
  yield takeEvery(updateTransaction.type, updateTransactionData);
  yield takeEvery(getAccountingSummary.type, fetchAccountingSummary);
  yield(takeEvery(getPaymentSummary.type, fetchPaymentSummary));
  yield(takeEvery(getCreditSummary.type, fetchCreditSummary));
  yield(takeEvery(getSubFilterDetails.type, fetchFilterSummaryDetails));
  yield takeEvery(getSaleGroupByBrand.type, fetchAccountingSummary);
  yield(takeEvery(getPaymentSummary.type, fetchPaymentSummary));
  yield(takeEvery(getCreditSummary.type, fetchCreditSummary));
  yield(takeEvery(getPaymentUserSummary.type, fetchPaymentUserSummary))
  yield takeEvery(getBillsDetails.type, fetchBillsDetails);
  yield takeEvery(sendDigiatlBillViaEmail.type, sendDigiatlBillViaEmailFunc);
  yield takeEvery(sendDigitalBillViaSMS.type, sendDigitalBillViaSMSFunc);
  yield takeEvery(getAuditLogDetails.type,fetchAuditLogDetails );
  yield takeEvery(sendDigiatlBillViaWA.type, sendDigiatlBillViaWAFunc);
  yield takeEvery(getInvoiceDetails.type, fetchInvoiceDetails);
  yield takeEvery(getUserCreditDetails.type, fetchUserCreditDetails);
  yield(takeEvery(getPaymentUserSummaryDetails.type,fetchPaymentUserSummaryDetails));
  yield takeEvery(uploadTrxnAttachment.type, uploadTrxnAttachmentFile);
  yield takeEvery(getFranciseReport.type, fetchFranchiseData);
}
